import { SxProps, Theme } from '@mui/material';

export const styles: Record<'button', SxProps<Theme>> = {
  button: {
    // custom breakpoint to match crisp chat window
    '@media (max-width: 479px)': {
      bottom: 76,
      height: 54,
      right: 14,
      width: 54,
    },
    bottom: 88,
    height: 60,
    minWidth: 'unset',
    position: 'fixed',
    right: 24,
    width: 60,
    zIndex: 1000000,
  },
};
